import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import { useCallback } from 'react';
import useContextOrStorage from '../../stream/useContextOrStorage';
/**
 * Hooks will provide `next` function of control$.
 *
 * @documented
 * @category State
 * @import import useControlNext from '@gef-ui/form-core/hooks/state/useControlNext'
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @returns {Function} [useControlNext] - or undefined if form is not yet registered
 * @example
 *
 * 	const next = useControlNext();
 *
 * 	next({type: 'SOME_ACTION'}); // send some action to next stream
 *
 */ const useControlNext = (formName)=>{
    const { control$ } = defaultToEmptyObject(useContextOrStorage(formName));
    const next = useCallback((action)=>control$.next(action), [
        control$
    ]);
    return control$ ? next : undefined;
};
export default useControlNext;
